import { useNavigate } from 'react-router-dom';
import BackButton from 'components/Button/BackButton'

export const ReleaseNotes = () => {
    const navigate = useNavigate();

    const goBack = () => {
        navigate(-1);
    }

    return (

        <div className="container msds-block-padding-small">
            <div className="row">
                <div className='col-12 mb-6'>
                    <BackButton id={"goBack"} onClickHandler={goBack} label={"Back"}></BackButton>
                </div>
                <div className='col-12'>
                    <div className='msds-text-display-3-regular msds-text-display-3 msds-text-gray-10 mb-6'>Release Notes</div>

                    <div className='msds-text-header-4 msds-text-gray-10 mb-6'>NOV 18TH,2025</div>
                    <div className="msds-divider msds-divider--gray-5 mb-6"></div>

                    <div className='msds-text-body-0-bold msds-text-clear-blue'>Bulk Camera Import via XLS</div>
                    <br /> 
                    <div className='msds-text-body-0 msds-text-gray-10'>
                        We’ve introduced a new option to <b>bulk import cameras directly from an XLS file,</b> enabling faster and more efficient camera entry.
                        <br /><br />
                        <b>What’s Changed:</b>
                        <br />
                        <ul>
                            <li><b>Bulk Import Capability:</b> Users can now upload multiple cameras at once using an XLS template.</li>
                            <br />
                            <li><b>Downloadable Template:</b> The XLS template is available directly from the feature in the tool, with clear instructions for each camera input element.</li>
                            <br />
                            <li><b>Streamlined Workflow:</b> This enhancement significantly reduces manual entry time and simplifies large-scale camera setup.</li>
                        </ul>
                    </div>
                    <div className='msds-text-body-0 msds-text-gray-10'>
                        <b>Looking Ahead:</b>
                        <br /><br />
                        In a future update, we will enable the ability to <b>upload camera groups without overwriting existing groups,</b> providing even greater flexibility for managing configurations.
                        <br />
                    </div>
                    <br />
                    <div className='msds-text-header-4 msds-text-gray-10 mb-6'>NOV 6TH,2025</div>
                    <div className="msds-divider msds-divider--gray-5 mb-6"></div>

                    <div className='msds-text-body-0-bold msds-text-clear-blue'>Quick Start</div>
                    <br />
                    <div className='msds-text-body-0 msds-text-gray-10'>
                        We’ve introduced Quick Start, a new feature designed to <b>simplify and accelerate project creation</b> when your design does not require a complex structure or deep hierarchy.
                        <br />
                        <br />
                        <b>What’s Changed:</b>
                        <br />
                        <ul>
                            <li><b>One-Step Design Creation:</b> Clicking <b>Quick Start</b> allows you to enter only a <b>Site Design Name</b> and immediately begin designing.</li>
                            <br />
                            <li><b>Optional Details:</b> Project name and site location are now optional, reducing setup time.</li>
                            <br />
                            <li><b>Super Fast Workflow:</b> With Quick Start, you can skip unnecessary steps and jump straight into the design process.</li>
                        </ul>
                    </div>
                    <div className='msds-text-body-0 msds-text-gray-10'>
                        <b>Why It Matters:</b>
                        <br /><br />
                        This feature is perfect for projects that need a fast start, enabling design starts in seconds.
                        <br />
                    </div>
                    <br />
                    <div className='msds-text-body-0-bold msds-text-clear-blue'>Improved Low FPS Bitrate Accuracy</div>
                    <br />
                    <div className='msds-text-body-0 msds-text-gray-10'>
                        We have refined bitrate calculations for streams with very low frame rates (1–5 FPS) to better account for the impact of keyframes. This ensures more accurate bitrate allocation and improved consistency in low-FPS scenarios.
                        <br />
                        <br />
                        <b>What’s Changed:</b>
                        <br />
                        <ul>
                            <li><b>Dynamic penalty adjustment increased:</b>  The penalty applied to keyframes now scales more aggressively at low FPS.</li>
                            <br />
                            <li><b>Bitrate ratio impact:</b> For streams between <b>1–5 FPS</b>, keyframe impact is now significantly higher than before with a sliding scale as FPS increase.</li>
                            <br />
                        </ul>
                    </div>
                    <div className='msds-text-body-0 msds-text-gray-10'>
                        <b>Why It Matters:</b>
                        <br />
                        <br />
                        These changes improve bitrate accuracy for low-FPS streams.
                        <br />
                        However, we <b>strongly recommend consulting your camera manufacturer</b> when determining the suggested bitrate for your specific environment and settings, as camera choice and configuration can greatly influence.
                        <br />
                    </div>
                    <br />
                    <div className='msds-text-header-4 msds-text-gray-10 mb-6'>JUNE 10TH,2025</div>
                    <div className="msds-divider msds-divider--gray-5 mb-6"></div>

                    <div className='msds-text-body-0-bold msds-text-clear-blue'>What's New</div>
                    <br /> 
                    <div className='msds-text-body-0-bold msds-text-clear-blue'>Release Highlights – Consolidated Solution Design Tool</div>
                    <br />
                    <div className='msds-text-body-0 msds-text-gray-10'>
                        <b>We now have a single design tool for Husky IVO and Generic Hardware specifications.</b>
                        <br />
                        <ul>
                            <li><b>IVO is now fully integrated into the generic design flow</b>, removing the need to create and manage two separate design tracks. This streamlines the process and ensures consistency across solution types.</li>
                            <br /> 
                            <li><b>Proposal generation</b> is now available for both IVO and generic designs from the same tool, enabling faster iterations and immediate feedback without switching tools. Simply create the project, enter the camera information and then under the “choose hardware type” select if the design should show a Husky IVO solution or Generic Hardware specification recommendation.</li>
                            <br /> 
                            <li><b>Camera specifications are now automatically reused</b>, so users no longer need to re-enter the same technical details when switching between IVO and generic designs, saving time and reducing manual input.</li>
                            <br />
                            <li><b>Improved user interface</b> delivers a more intuitive and efficient design experience, with clearer navigation, better layout, and smarter defaults. </li>
                            <br /> 
                            <li><b>Reduced design time</b> is achieved through automation of repetitive tasks and intelligent defaults that adapt to the selected design path. </li>
                            <br />
                        </ul>
                    </div>


                    <div className='msds-text-body-0-bold msds-text-clear-blue'>Enhanced Husky IVO Filtering and Proposal Generation</div>
                    <br />
                    <div className='msds-text-body-0 msds-text-gray-10'>
                        The latest update introduces powerful new filtering and configuration options for IVO-based designs, giving users greater control and clarity during the solution design process.
                        <br /> 
                        <div className='msds-text-body-0-bold'>Advanced IVO Filtering Capabilities</div>
                        <br />
                        Users can now filter IVO models based on the following parameters:
                        <br /> 
                        <ul>
                            <li><b>IVO Model</b></li>
                            <li><b>Form Factor </b>(e.g., 1U, 2U)</li>
                            <li><b>Disk Quantity</b></li>
                            <li><b>RAID Array Type</b></li>
                        </ul>
                        These filters are <b>interdependent</b>, meaning the available options dynamically adjust based on your selections. For example:
                        <br />
                        <ul>
                            <li>Selecting a  <b>RAID type</b>  will automatically limit the IVO model list to only those that support the chosen RAID configuration.</li>
                            <br /> 
                            <li>Choosing a  <b>form factor</b>  like 1U will filter both the IVO models and RAID types to only those compatible with that chassis size. </li>
                            <br /> 
                        </ul>
                        This logic-driven filtering ensures that only valid and supported combinations are presented, reducing errors and improving design accuracy.
                       
                    </div>
                    <br /> <br />
                    <div className='msds-text-body-0-bold msds-text-clear-blue'>For Husky IVO Disk and System Utilization Sliders</div>
                    <br />
                    <div className='msds-text-body-0 msds-text-gray-10'>
                        We’ve now  <b>separated disk utilization and system utilization </b> into two distinct sliders for more granular control:
                        <br /> 
                        <ul>
                            <li><b>Disk Utilization Slider:</b> Controls how much of the disk capacity is used in the design.</li>
                            <br />
                            <li><b>System Utilization Slider:</b> Controls the overall system load, including CPU and memory.</li>
                            <br />
                        </ul>
                        At <b>100% utilization</b>, no additional buffer is applied by the user. However, the engine still includes a  <b>built-in safety margin</b>, calculated from internal test failure thresholds to ensure system stability.
                        <br /> 
                        <ul>
                            <li><b>Default values</b> are: </li>
                            <br />
                            <ul>
                                <li><b>80% for Disk Utilization</b></li>
                                <li><b>90% for System Utilization</b></li>
                            </ul>
                        </ul>
                        <br /> 
                        These defaults provide a balanced buffer for most scenarios. If you anticipate future system expansion, you can adjust these sliders accordingly to accommodate growth.
                        <br /> 
                    </div>

                    <div className='msds-text-body-0-bold msds-text-clear-blue'>Husky IVO Generate Proposal – Smarter Recommendations</div>
                    <br />
                    <div className='msds-text-body-0 msds-text-gray-10'>
                        Once filters and parameters are set, the  <b>Generate Proposal</b>  feature delivers a tailored solution based on your inputs. The proposal includes a <b> clear and comprehensive overview </b> with insights such as:
                        <br /> 
                        <ul>
                            <li><b>Total required storage</b> for the design</li>
                            <li><b>Storage per server</b></li>
                            <li><b>RAID type used</b></li>
                            <li><b>System utilization percentage</b></li>
                            <li><b>Camera streams per server</b></li>
                            <li><b>Camera data rate per server</b></li>
                            <li><b>Smart Client data rate per server</b> (based on pass-through mode, where recording servers forward streams to Smart Clients)</li>
                            <br />
                        </ul>
                        This level of detail ensures transparency and helps users make informed decisions when finalizing their system architecture.
                    </div>
                    <br />
                    <br />
                </div>

                <div className='col-12'>
                    <div className='msds-text-header-4 msds-text-gray-10 mb-6'>October 9th, 2023</div>
                    <div className="msds-divider msds-divider--gray-5 mb-6"></div>

                    <div className='msds-text-body-0-bold msds-text-clear-blue'>What's New</div>
                    <div className='msds-text-body-0 msds-text-gray-10'>
                        The new server calculator developed by Milestone is an innovative tool which has been designed to empower Integrators and presales, providing them with a feature-rich and simplistic approach to solution design.
                        <br /> <br />
                        We have listened to your feedback and had the primary objective to create an efficient, effective solution tool, that can take away the burden of designing server solutions.
                        <br /> <br />
                        To achieve this ambitious goal, we implemented a design change with carefully constructed user input elements, that default to best practice and logical choices. Coupled with a much-simplified user experience (UX) flow. This means that the tool is fast, intuitive, and easy to use, allowing users to quickly input the necessary information and generate results.
                        <br /> <br />
                    </div>

                    <div className='msds-text-body-0-bold msds-text-clear-blue'>Realtime</div>
                    <div className='msds-text-body-0 msds-text-gray-10'>
                        Furthermore, we now have a <b>real-time</b> design proposal feature. This dynamic and responsive nature of the calculator allows users to experiment with different scenarios and configurations on the fly. You can adjust variables, such as camera specifications, or server variables and witness how these modifications affect the proposed solution in real-time. By providing instant feedback, the calculator empowers users to make informed decisions and fine-tune their designs effortlessly.
                        <br /> <br />
                    </div>

                    <div className='msds-text-body-0-bold msds-text-clear-blue'>Lens Type</div>
                    <div className='msds-text-body-0 msds-text-gray-10'>
                        When creating a new camera group the default is single lens, but you can now select Multi lens, which allows you to select additional streams. The benefit here is the overall output indicates the correct camera count whilst taking all of the streams into account performance and storage wise.
                        <br /> <br />
                    </div>

                    <div className='msds-text-body-0-bold msds-text-clear-blue'>Defaults</div>
                    <div className='msds-text-body-0 msds-text-gray-10'>
                        For simplicity, and speed, the servers TAB has default logic built in,  which means a standard new project assumes that the user wants an all-in-one server without archiving, with spinning hard disks and a RAID 5. If you select archiving then the defaults dynamically adjust to a RAID 10 for the live array with SSD disks, and a RAID 5 with spinning disks for the archive. It is possible to manually tweak and change these settings.
                        <br /> <br />
                    </div>

                    <div className='msds-text-body-0-bold msds-text-clear-blue'>UI Tab for the Recording parameters</div>
                    <div className='msds-text-body-0 msds-text-gray-10'>
                        This is a new simple UI design, where a simple drop down allows you to quickly decide which recording parameter should be used for each camera group.
                        <br /> <br />
                        Options are constant, motion based and speedup.
                        <br /> <br />
                        Speedup is redesigned, and provides 2 entries for frame rate “FPS”. Baseline is the constant slow rate (here we recommend 1 FPS, also known as keyframe recording), and then your speedup FPS of choice. The reason setting 1 FPS as your desired FPS, is best, is due to how H.264/5 works. 1 FPS gives your desired FPS results a smooth transition. Where any other FPS, say 5, can result in a reinitialization of the stream, and a small blip in the recording.
                        <br /> <br />
                    </div>

                    <div className='msds-text-body-0-bold msds-text-clear-blue'>Bulk Apply</div>
                    <div className='msds-text-body-0 msds-text-gray-10'>
                        Now, apply specific camera settings to all camera groups simultaneously with ease. This feature is a time-saver, especially when re-editing a design where changes like retention period or other settings need to be uniformly applied to all cameras.
                        <br /> <br />
                        For instance, if you need to modify the retention period across all camera groups, the Bulk Apply feature allows you to make this adjustment swiftly and efficiently, ensuring consistency across all settings.
                        <br /> <br />
                        Explore the available options and see how the Bulk Apply feature can streamline your workflow. Refer to the image below for a detailed view of the available options.
                        <br /> <br />
                        <img className='d-block mx-auto' src={require("./Images/bulk-apply.png")} alt={"Bulk Apply"} />
                        <br /> <br />
                    </div>

                    <div className='msds-text-body-0-bold msds-text-clear-blue'>Projects</div>
                    <div className='msds-text-body-0 msds-text-gray-10'>
                        This enhancement allows designs of large-scale projects encompassing multiple locations and sites.
                        <br /> <br />
                        The intention is that each site and server design use a suitable naming convention which correlates with its purpose.
                        <br /> <br />
                        Refer to the image below to visualize the concept and gather inspiration for implementing this innovative feature in your projects.
                        <br /> <br />
                        Note, a fast-track project start will be implemented for small projects.
                        <br /> <br />
                        <img className='d-block mx-auto' src={require("./Images/projects.png")} alt={"Projects"} />
                        <br /> <br />
                    </div>

                </div>
            </div>
        </div>
    )
}
